namespace Portico.Directives {

    import Inject = Portico.Decorators.Inject;
    import pme = Portico.Models.Enterprise;
    import ps = Portico.Services;

    export class ITcInputOptions {
        addressKey: string;
        cityKey: string;
        stateKey: string;
        zipKey: string;
    }

    class GoogleFormattedAddress {
        searchedBy: string;
        address1: string;
        city: string;
        state: string;
        zip: string;

        constructor(private googleResponse = {} as any) {
            this.searchedBy = googleResponse.searchedBy ? googleResponse.searchedBy : "";
            this.address1 = googleResponse.street_number ? googleResponse.street_number + " " + googleResponse.route : googleResponse.route;
            this.city = googleResponse.locality ? googleResponse.locality : "";
            this.state = googleResponse.administrative_area_level_1 ? googleResponse.administrative_area_level_1 : "";
            this.zip = googleResponse.postal_code ? googleResponse.postal_code : "";
        }
    }

    export class ITcInputController {
        change: () => void;
        controlClass: string;
        disabled: string;
        dateOptions: string;
        groupClass: string;
        index: string;
        inputClass: string;
        isAllowed: () => boolean;
        key: string;
        label: string;
        labelClass: string;
        list: string;
        listLabel: string;
        listOptions: string;
        listTrackBy: string;
        listValue: string;
        mask: string;
        maskInclude: string;
        max: string;
        maxlength: string;
        maxlengthMessage: string;
        messageClass: string;
        min: string;
        minlength: string;
        minlengthMessage: string;
        options: ITcInputOptions;
        pattern: string;
        patternMessage: string;
        placeholder: string;
        readonly: string;
        required: string;
        requiredMessage: string;
        rows: string;
        type: string;
        utc: string;
        valueDefault: string;
        valueNone: string;

        tcForm: ITcFormController;
        id: string;
        isOpen: boolean;
        value: any;

        isDisabled: () => boolean;
        onChange: () => void;
    }

    @Inject('$scope', 'locationServiceClient')  // TODO - Change back to locationService once the API Gateway is in production
    export class TcInputController implements ITcInputController {
        change: () => void;
        controlClass: string;
        disabled: string;
        dateOptions: string;
        groupClass: string;
        index: string;
        inputClass: string;
        isAllowed: () => boolean;
        key: string;
        label: string;
        labelClass: string;
        list: string;
        listLabel: string;
        listOptions: string;
        listTrackBy: string;
        listValue: string;
        mask: string;
        maskInclude: string;
        max: string;
        maxlength: string;
        maxlengthMessage: string;
        messageClass: string;
        min: string;
        minlength: string;
        minlengthMessage: string;
        options: ITcInputOptions;
        pattern: string;
        patternMessage: string;
        placeholder: string;
        readonly: string;
        required: string;
        requiredMessage: string;
        rows: string;
        type: string;
        utc: string;
        valueDefault: string;
        valueNone: string;

        tcForm: ITcFormController;
        id: string;
        isOpen: boolean = false;
        value: any;

        constructor(
            private $scope: angular.IScope,
            private locationService: ps.ILocationService,
        ) {
        }

        isDisabled(): boolean {
            if (this.disabled === 'true' || (this.tcForm && this.tcForm.isDisabled())) {
                return true;
            }

            if (this.isAllowed && !this.isAllowed()) {
                return true;
            }

            return false;
        }

        onChange(): void {
            if (this.type === 'consent' || this.type.indexOf('checkbox') >= 0 && this.list) {
                this.checkbox();
            } else if (this.type.indexOf('date') === 0) {
                this.datePicker();
            } else if (this.type === 'zip-lookup') {
                this.zipLookup();
            } else if (this.type === 'google-autocomplete') {
                this.googleAutoComplete();
            }

            if (this.change) {
                this.change();
            }
        }

        private checkbox(): void {
            const values: any[] = [];

            for (let key in this.value) {
				if (this.value[key] && this.value[key] != this.valueNone) {
                    values.push(this.value[key]);
                }
            }

            if (values.length === 0 && this.valueNone != null) {
                values.push(parseInt(this.valueNone));
            }

            this.$scope.$eval(`${this.key}=v`, { v: values });
        }

        private datePicker(): void {
            if (this.max || this.min) {
                const value: Date = this.$scope.$eval(`${this.key}`);
                this.tcForm.ngForm[this.id].$setValidity('max', true);
                this.tcForm.ngForm[this.id].$setValidity('min', true);

                if (this.max) {
                    this.tcForm.ngForm[this.id].$setValidity('max', value <= new Date(this.max));
                }

                if (this.min) {
                    this.tcForm.ngForm[this.id].$setValidity('min', value >= new Date(this.min));
                }
            }
        }

        private zipLookup(): void {
            const value: string = this.$scope.$eval(`${this.key}`);

            if (value && value.length === 5) {
                this.locationService.getCities(value).then((response: pme.City[]) => {
                    if (response.length > 0) {
                        this.$scope.$eval(`${this.options.cityKey}=cn`, { cn: response[0].cityName });
                        this.$scope.$eval(`${this.options.stateKey}=sa`, { sa: response[0].stateAbbr });
                    } else {
                        this.$scope.$eval(`${this.options.cityKey}=cn`, { cn: null });
                        this.$scope.$eval(`${this.options.stateKey}=sa`, { sa: null });
                    }
                });
            }
        }

        private googleAutoCompleteForm(address: GoogleFormattedAddress) {
            const value: string = this.$scope.$eval(`${this.key}`);
            if (value) {
                var inputKey = this.key.replace(/[\.\'\$\[\]\(\)]+/g, '_');
                var inputId = inputKey + '-input';
                var element = document.getElementById(inputId) as HTMLInputElement;
                element.value = address.address1; //sets to address line of the google result, and clears out the complete address result.
                this.$scope.$eval(`${this.options.addressKey} = adr`, { adr: address.address1 });
                this.$scope.$eval(`${this.options.cityKey}= cn`, { cn: address.city });
                this.$scope.$eval(`${this.options.stateKey}= sa`, { sa: address.state });
                this.$scope.$eval(`${this.options.zipKey}= zp`, { zp: address.zip });
            } else {
                this.$scope.$eval(`${this.options.addressKey}= adr`, { adr: null });
                this.$scope.$eval(`${this.options.cityKey}= cn`, { cn: null });
                this.$scope.$eval(`${this.options.stateKey}= sa`, { sa: null });
                this.$scope.$eval(`${this.options.zipKey}= zp`, { zp: null });
            }
        }

        private googleAutoCompleteConvertToFriendlyObject(place) {
            var result = {} as any;
            if (place) {
                result.searchedBy = place.address_components[0].types[0];
                for (var i = 0, l = place.address_components.length; i < l; i++) {
                    result[place.address_components[i].types[0]] =
                        place.address_components[i].short_name;
                }
                result.formattedAddress = place.formatted_address;
                result.lat = place.geometry.location.lat();
                result.lng = place.geometry.location.lng();
            }
            return result;
        }

        private googleAutoComplete() {
            var options = {
                types: ['address'],
                componentRestrictions: { country: "us" }
            };
            var inputKey = this.key.replace(/[\.\'\$\[\]\(\)]+/g, '_');
            var inputId = inputKey + '-input';
            var element = document.getElementById(inputId) as HTMLInputElement;
            var gPlace = new google.maps.places.Autocomplete(element, options);
            google.maps.event.addListener(gPlace,
                'place_changed',
                () => {
                    this.$scope.$apply(() => {
                        var place = gPlace.getPlace();
                        var details = this.googleAutoCompleteConvertToFriendlyObject(place);
                        var googleFormattedAddress = new GoogleFormattedAddress(details);
                        this.googleAutoCompleteForm(googleFormattedAddress);
                    });
                });
        }
    }

    angular.module('app').directive('tcInput', [
        '$compile',
        '$filter',
        '$stateParams',
        'dataService',
        (
            $compile: angular.ICompileService,
            $filter: angular.IFilterService,
            $stateParams: angular.ui.IStateParamsService,
            dataService: ps.IDataService
        ) => {
            return {
                bindToController: {
                    change: '&?',
                    controlClass: '@',
                    disabled: '@',
                    dateOptions: '@',
                    groupClass: '@',
                    index: '@',
                    inputClass: '@',
                    isAllowed: '&?',
                    key: '@',
                    label: '@',
                    labelClass: '@',
                    list: '=',
                    listLabel: '@',
                    listOptions: '@',
                    listTrackBy: '@',
                    listValue: '@',
                    mask: '@',
                    maskInclude: '@',
                    max: '@',
                    maxlength: '@',
                    maxlengthMessage: '@',
                    messageClass: '@',
                    min: '@',
                    minlength: '@',
                    minlengthMessage: '@',
                    options: '=?',
                    pattern: '@',
                    patternMessage: '@',
                    placeholder: '@',
                    readonly: '@',
                    required: '@',
                    requiredMessage: '@',
                    rows: '@',
                    type: '@',
                    utc: '@',
                    valueDefault: '@',
                    valueNone: '@'
                },
                controller: <any>TcInputController,
                controllerAs: '$input',
                link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[], $transclude: angular.ITranscludeFunction) => {
                    const tcInput: ITcInputController = $ctrl[0];
                    const tcForm: ITcFormController = $ctrl[1];

                    if (tcForm) {
                        tcInput.tcForm = tcForm;
                        tcForm.tcInputs.push(tcInput);
                    }

                    const index: string = tcInput.index ? tcInput.index : '';
                    const key: string = tcInput.key ? tcInput.key : '';
                    const type = tcInput.type ? tcInput.type : 'text';

                    tcInput.id = key.replace(/[\.\'\$\[\]\(\)]+/g, '_');

                    if (index) {
                        tcInput.id += '-' + index.replace(/[\.\'\$\[\]\(\)]+/g, '_');
                    }

                    let value = $scope.$eval(`${key}`);

                    if (value == null) {
                        if (tcInput.valueDefault != null) {
                            value = tcInput.valueDefault;
                        } else if (tcInput.valueNone != null) {
                            value = tcInput.valueNone;
                        }
                    }

                    if (value != null) {
                        if (tcInput.type.indexOf('date') === 0) {
                            value = new Date(value);
                        }

                        $scope.$eval(`${tcInput.key}=v`, { v: value });
                    }

                    if (Array.isArray(value)) {
                        tcInput.value = {};

                        for (let i = 0; i < value.length; i++) {
                            tcInput.value['' + value[i]] = value[i];
                        }
                    } else {
                        tcInput.value = value;
                    }

                    ///////////
                    // LABEL //
                    ///////////

                    let labelHtml = '';

                    if (tcInput.label) {
                        const labelClass = tcInput.labelClass ? tcInput.labelClass : '';
                        const append = tcInput.required === 'append' ? '<span class="required">*</span>' : '';
                        const prepend = tcInput.required === 'prepend' || tcInput.required === 'true' ? '<span class="required">*</span>' : '';

                        labelHtml =
                            `<div class="${labelClass}" id="${tcInput.id}-label">
								<label class="control-label" for="${tcInput.id}-input">
									${prepend}${tcInput.label}${append}
								</label>
							</div>`;
                    }

                    ///////////
                    // INPUT //
                    ///////////

                    let inputClass = (type.indexOf('checkbox') === 0 || type === 'file' || type === 'monaco' || type.indexOf('radio') === 0 || type === 'select' || type === 'textarea' || type.indexOf('triple') === 0 || type === 'consent' ? '' : 'form-control');
                    inputClass += (tcInput.inputClass ? ' ' + tcInput.inputClass : '');
                    // these are trialcard attributes that should be passed along to child directives
                    let childAttrs = '';
                    let inputAttrs = '';
                    let inputHtml = '';
                    let transclusion = '';

                    $transclude(function (clone, scope) {
                        clone.each(function (index, node) {
                            transclusion += node.textContent ? node.textContent : node.outerHTML;
                        });
                    });

                    childAttrs += `change="$input.onChange()" `;
                    inputAttrs += `ng-change="$input.onChange()" `;

                    if (tcInput.disabled) {
                        childAttrs += `disabled="${tcInput.disabled}" `;
                        inputAttrs += `disabled="${tcInput.disabled}" `;
                    }

                    if (tcInput.isAllowed) {
                        childAttrs += `is-allowed="$input.isAllowed()" `;
                    }

                    if (inputClass) {
                        childAttrs += `input-class="${inputClass}" `;

                        if (type.indexOf('checkbox') < 0 && type.indexOf('radio') < 0) {
                            inputAttrs += `class="${inputClass}" `;
                        }
                    }

                    if (tcInput.listLabel) {
                        childAttrs += `list-label="${tcInput.listLabel}" `;
                    }

                    if (tcInput.listOptions) {
                        childAttrs += `list-options="${tcInput.listOptions}" `;
                    }

                    if (tcInput.listTrackBy) {
                        childAttrs += `list-track-by="${tcInput.listTrackBy}" `;
                    }

                    if (tcInput.listValue) {
                        childAttrs += `list-value="${tcInput.listValue}" `;
                    }

                    if (tcInput.mask) {
                        childAttrs += `mask="${tcInput.mask}" `;

                        if (tcInput.mask === 'date') {
                            inputAttrs += `ui-mask="99/99/9999" ui-mask-placeholder ui-mask-placeholder-char="space" ui-options="{ allowInvalidValue: true }" `;
                        } else if (tcInput.mask === 'phone') {
                            inputAttrs += `ui-mask="(999) 999-9999" ui-mask-placeholder ui-mask-placeholder-char="space" ui-options="{ allowInvalidValue: true }" `;
                        } else if (tcInput.mask === 'zip') {
                            inputAttrs += `ui-mask="99999" ui-mask-placeholder ui-mask-placeholder-char="space" ui-options="{ allowInvalidValue: true }" `;
                        } else if (tcInput.mask) {
                            inputAttrs += `ui-mask="${tcInput.mask}" ui-mask-placeholder ui-mask-placeholder-char="space" ui-options="{ allowInvalidValue: true }" `;
                        }

                        if (tcInput.maskInclude === 'true') {
                            inputAttrs += `model-view-value="true" `;
                        }
                    }

                    if (tcInput.maxlength) {
                        childAttrs += `maxlength="${tcInput.maxlength}" `;
                        inputAttrs += `ng-maxlength="${tcInput.maxlength}" maxlength="${tcInput.maxlength}" `;
                    }

                    if (tcInput.minlength) {
                        childAttrs += `minlength="${tcInput.minlength}" `;
                        inputAttrs += `ng-minlength="${tcInput.minlength}" `;
                    }

                    if (tcInput.pattern) {
                        childAttrs += `pattern="${tcInput.pattern}" `;

                        if (tcInput.pattern === 'email') {
                            inputAttrs += `ng-pattern="/^[a-z0-9!#\$%&'*+\\/=?^_\`{|}~.-]+@[a-z0-9-]+(\\.[a-z0-9-]+)+\$/i" `;
                        } else {
                            inputAttrs += `ng-pattern="${tcInput.pattern}" `;
                        }
                    }

                    if (tcInput.placeholder) {
                        childAttrs += `placeholder="${tcInput.placeholder}" `;
                        inputAttrs += `placeholder="${tcInput.placeholder}" `;
                    }

                    if (tcInput.readonly) {
                        childAttrs += `readonly="${tcInput.readonly}" `;
                        inputAttrs += `readonly="readonly" `;
                    }

                    if (tcInput.required) {
						if (dataService.session.mode !== 'edit' && dataService.session.mode !== 'mock') {
                            childAttrs += `required="${tcInput.required}" `;
                            inputAttrs += `required="required" `;
                        }
                    }

                    if (tcInput.rows) {
                        childAttrs += `rows="${tcInput.rows}" `;
                        inputAttrs += `rows="${tcInput.rows}" `;
                    }

                    if (type.indexOf('checkbox') === 0 || type.indexOf('radio') === 0 || type === 'consent') {
                        let inline = type.indexOf('-inline') > 0;
                        let tag = inline ? 'span' : 'div';

                        if (type.indexOf('-button') > 0) {
                            inputAttrs += `class="tc-hide" `;
                        }

                        if (tcInput.list) {
                            const itemLabel = (transclusion !== '' ? transclusion : (tcInput.listLabel ? `{{item.${tcInput.listLabel}}}` : '{{item}}')).replace(/"/g, '&quot;');
                            const itemValue = (tcInput.listValue ? `item.${tcInput.listValue}` : 'item');
                            let innerHtml = '';
                            let labelAttrs = '';

                            if(type === 'consent') {
                                inputHtml += `<label ng-repeat="item in $input.list" ng-if="${itemValue} != $input.valueNone" for="${tcInput.id}-input-{{$index}}" class="${tcInput.labelClass ? tcInput.labelClass : ''}">
                                    <input id="${tcInput.id}-input-{{$index}}" name="${tcInput.id}" type="checkbox" ng-blur="$input.focus[$index] = false" ng-disabled="$input.isDisabled()" ng-focus="$input.focus[$index] = true" ng-model="$input.value[${itemValue}]" ng-true-value="{{${itemValue}}}" ${inputAttrs} />                                
                                    <span  class="consent-content">${tcInput.label}</span>                                        
                                </label>`;
                            } else {
                                if (type.indexOf('checkbox') >= 0) {
                                    innerHtml += `<input id="${tcInput.id}-input-{{$index}}" name="${tcInput.id}" type="checkbox" ng-blur="$input.focus[$index] = false" ng-disabled="$input.isDisabled()" ng-focus="$input.focus[$index] = true" ng-model="$input.value[${itemValue}]" ng-true-value="{{${itemValue}}}" ${inputAttrs} />`;
                                } else if (type.indexOf('radio') >= 0) {
                                    innerHtml += `<input id="${tcInput.id}-input-{{$index}}" name="${tcInput.id}" type="radio" ng-blur="$input.focus[$index] = false" ng-disabled="$input.isDisabled()" ng-focus="$input.focus[$index] = true" ng-model="${key}" ng-value="${itemValue}" ${inputAttrs} />`;
                                }
    
                                if (type === 'checkbox-button') {
                                    labelAttrs += `class="btn btn-block btn-default" ng-class="{'checked': $input.value[${itemValue}] === ${itemValue}, 'focus': $input.focus[$index]}" `;
                                } else if (type === 'radio-button') {
                                    labelAttrs += `class="btn btn-block btn-default" ng-class="{'checked': ${key} === ${itemValue}, 'focus': $input.focus[$index]}" `;
                                }
    
								if (tcInput.listTrackBy) {
									inputHtml =
										`<${tag} ${inline ? '' : 'class="row flat"'}>
											<${tag} class="${inputClass}" ng-repeat="item in $input.list track by item.${tcInput.listTrackBy}" ng-if="${itemValue} != $input.valueNone">
												<label for="${tcInput.id}-input-{{$index}}" ${labelAttrs}>
													${innerHtml}
													<tc-content html="${itemLabel}"/>
												</label>
											</${tag}>
										</${tag}>`;
								} else {
									inputHtml =
										`<${tag} ${inline ? '' : 'class="row flat"'}>
											<${tag} class="${inputClass}" ng-repeat="item in $input.list" ng-if="${itemValue} != $input.valueNone">
												<label for="${tcInput.id}-input-{{$index}}" ${labelAttrs}>
													${innerHtml}
													<tc-content html="${itemLabel}"/>
												</label>
											</${tag}>
										</${tag}>`;
								}
                            }
                        } else {
                            let innerHtml = '';
                            let labelAttrs = '';

                            if (type.indexOf('checkbox') >= 0 || type == 'consent') {
                                innerHtml += `<input id="${tcInput.id}-input" name="${tcInput.id}" type="checkbox" ng-blur="$input.focus = false" ng-disabled="$input.isDisabled()" ng-focus="$input.focus = true" ng-model="${key}" ng-true-value="${tcInput.listValue}" ${inputAttrs} />`;
                            } else if (type.indexOf('radio') >= 0) {
                                innerHtml += `<input id="${tcInput.id}-input" name="${tcInput.id}" type="radio" ng-blur="$input.focus = false" ng-disabled="$input.isDisabled()" ng-focus="$input.focus = true" ng-model="${key}" ng-value="${tcInput.listValue}" ${inputAttrs} />`;
                            }

                            if (type.indexOf('-button') > 0) {
                                labelAttrs += `class="btn btn-block btn-default" ng-class="{'checked': ${key} === ${tcInput.listValue}, 'focus': $input.focus}" `;
                            }

                            if(type === 'consent') {
                                inputHtml = 
                                    `<label for="${tcInput.id}-input" ${labelAttrs}>
                                        ${innerHtml}
                                        <span  class="consent-content">${tcInput.label}</span>                                        
                                    </label>`
                            } else {
                                inputHtml =
                                    `<div class="row flat">
                                        <div class="${inputClass}">
                                            <label for="${tcInput.id}-input" ${labelAttrs}>
                                                ${innerHtml}
                                                ${tcInput.listLabel}
                                            </label>
                                        </div>
                                    </div>`;
                            }
                        }
                    }
                    else if (type === 'color-picker') {
                        inputHtml =
                            `<span class="input-group">
                                <input class="${inputClass}"  id="${tcInput.id}-input" name="${tcInput.id}" ng-disabled="$input.isDisabled()" ng-model="${key}" type="text" ${inputAttrs} />
                                <span class="input-group-btn">
									<button colorpicker type="button" style="background-color: {{ ${key} }};" class="btn btn-default btn-lg" ng-model="${key}" ng-click="$input.isOpen = true" ng-disabled="$input.isDisabled()"><i class="glyphicon glyphicon-triangle-bottom"></i></button>
								</span>
							</span>`;
                    } else if (type.indexOf('date') === 0) {
                        let options = '';

                        if (tcInput.max || tcInput.min) {
                            // const today = $filter('date')(new Date(), 'MM/dd/yyyy');
                            options += `datepicker-options="{ `;

                            if (tcInput.max) {
                                options += `maxDate: '${tcInput.max}', `;
                            }

                            if (tcInput.min) {
                                options += `minDate: '${tcInput.min}', `;
                            }

                            if(tcInput.dateOptions){
                                const dateOptions = tcInput.dateOptions.replace(/[\{\}]+/g, '').split(',');                                
                                for(let o of dateOptions){
                                    options += `${o.trim()}, `;
                                }
                            }

                            // options += `initDate: '${today}' }" `;
                            options += ` }" `;
                        }

                        if(tcInput.utc){
                            options += `ng-model-options="{timezone: 'utc'}" `;
                        }

                        inputAttrs += `is-open="$input.isOpen" model-view-value="true" show-button-bar="false" uib-datepicker-popup="MM/dd/yyyy" ui-mask="99/99/9999" ui-mask-placeholder ui-mask-placeholder-char="_" ${options} `;

                        if (type.indexOf('-picker') === -1) {
                            inputHtml =`<input class="${inputClass}" id="${tcInput.id}-input" name="${tcInput.id}" ng-disabled="$input.isDisabled()" ng-model="${key}" type="text" ${inputAttrs} />`;
                        } else {
                            inputHtml =
                                `<span class="input-group">
									<input class="${inputClass}" id="${tcInput.id}-input" name="${tcInput.id}" ng-disabled="$input.isDisabled()" ng-model="${key}" type="text" ${inputAttrs} />
									<span class="input-group-btn">
										<button type="button" class="btn btn-default btn-lg" ng-click="$input.isOpen = true" ng-disabled="$input.isDisabled()"><i class="glyphicon glyphicon-calendar"></i></button>
									</span>
								</span>`;
                        }
                    } else if (type.indexOf('monaco') === 0) {
                        const language = _.last(type.split('-')).toLowerCase();
                        const theme = type.indexOf('monaco-dark') === 0 ? 'vs-dark':'vs'
                        inputHtml = `<div id="${tcInput.id}-monaco" style="border:1px solid grey; height: ${20 * parseInt(tcInput.rows || '10')}px; resize: vertical; width: 100%;" ng-model="${key}" tc-monaco="${language}" theme="${theme}" />`;
                    } else if (type === 'select') {
                        inputHtml =
                            `<tc-select input-class="${inputClass}" key="${key}" list="$input.list" ${childAttrs} >
								${transclusion}
							</tc-select>`;
                    } else if (type === 'textarea') {
                        inputHtml = `<tc-textarea input-class="${inputClass}" key="${key}" ${childAttrs} />`;
                    } else if (type === 'triple-date') {                        
                        childAttrs += tcInput.placeholder ? 'placeholder-month="Month" placeholder-day="Day" placeholder-year="Year" ':'';
                        inputHtml = `<tc-triple-date input-class="${inputClass}" key="${key}" ${childAttrs} />`;
                    } else if (type === 'triple-phone') {
                        inputHtml = `<tc-triple-phone input-class="${inputClass}" key="${key}" ${childAttrs} />`;
                    } else if (type === 'zip-lookup' || type === 'google-autocomplete') {
                        inputHtml = `<input class="${inputClass}" id="${tcInput.id}-input" name="${tcInput.id}" ng-disabled="$input.isDisabled()" ng-model="${key}" type="text" ${inputAttrs} />`;
                    } else {
                        inputHtml = `<input class="${inputClass}" id="${tcInput.id}-input" name="${tcInput.id}" ng-disabled="$input.isDisabled()" ng-model="${key}" type="${type}" ${inputAttrs} />`; // ng-minlength="3"
                    }

                    /////////////
                    // MESSAGE //
                    /////////////

                    let messageAttrs = '';
                    let messageHtml = '';
                    let messageItems = '';

                    if (tcInput.messageClass) {
                        messageAttrs += `class="${tcInput.messageClass}" `;
                    }

                    if (tcInput.maxlengthMessage) {
                        messageItems +=
                            `<li ng-if="$input.tcForm.ngForm['${tcInput.id}'].$error.maxlength">
								${tcInput.maxlengthMessage}
							</li>`;
                    }

                    if (tcInput.minlengthMessage) {
                        messageItems +=
                            `<li ng-if="$input.tcForm.ngForm['${tcInput.id}'].$error.minlength">
								${tcInput.minlengthMessage}
							</li>`;
                    }

                    if (tcInput.patternMessage) {
                        messageItems +=
                            `<li ng-if="$input.tcForm.ngForm['${tcInput.id}'].$error.pattern">
								${tcInput.patternMessage}
							</li>`;
                    }

                    if (tcInput.requiredMessage) {
                        messageItems +=
                            `<li ng-if="$input.tcForm.ngForm['${tcInput.id}'].$error.required">
								${tcInput.requiredMessage}
							</li>`;
                    }

                    if (messageItems.length > 0) {
                        messageHtml =
                            `<div id="${tcInput.id}-message" ng-if="$input.tcForm.ngForm['${tcInput.id}'].$invalid && ($input.tcForm.ngForm.$submitted || $input.tcForm.ngForm['${tcInput.id}'].$dirty)" ${messageAttrs}>
								<ul class="has-error">
									${messageItems}
								</ul>
							</div>`;
                    }

                    const controlClass = tcInput.controlClass ? tcInput.controlClass : '';
                    let groupClass = (tcInput.type !== 'file' ? 'form-group' : '');

                    groupClass += (tcInput.groupClass ? ' ' + tcInput.groupClass : '');

                    const html =
                        `<div class="${groupClass}" id="${tcInput.id}-group" ng-class="{ 'has-error': $input.tcForm.ngForm['${tcInput.id}'].$invalid && ($input.tcForm.ngForm.$submitted || $input.tcForm.ngForm['${tcInput.id}'].$dirty) }">
                            ${type === 'consent' ? '': labelHtml}
                            <div class="${controlClass}" id="${tcInput.id}-control">
                                ${inputHtml}
                            </div>
                            ${messageHtml}
                        </div>`;                    

                    $element.html(html);
                    $compile($element.contents() as any)($scope);
                },
                restrict: 'E',
                require: ['tcInput', '?^tcForm'],
                scope: true,
                transclude: true
            };
        }
    ]);
}